import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrIcalSource.ts
var t = () => e("icalSource");
//#endregion
export { t as useTrIcalSource };
